import { render, staticRenderFns } from "./EditRules.vue?vue&type=template&id=ea1d65c2&"
import script from "./EditRules.vue?vue&type=script&lang=js&"
export * from "./EditRules.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports